import { useBemCN } from "@gik/core/utils/bemBlock";
import React from "react";

// ponytail: react-color's default saturation/hue pointers are ~4px and hard to
// see; this is the shared round handle used by both so the active point is obvious.
export function PickerPointer() {
	const bem = useBemCN("picker-pointer");
	return <div {...bem()} />;
}
